module.exports = __webpack_public_path__ + "static/img/about-banner01.6320039b.webp";